import { Column } from './Header'

export const columns: Column[] = [
  { name: '', style: { width: '10%' } },
  { name: 'lineCode', style: { width: '10%' } },
  { name: 'partNum', style: { width: '10%', minWidth: '174px' } },
  { name: 'description', style: { width: '20%' } },
  { name: 'comments', style: { width: '20%' } },
  { name: 'qty', style: { width: '10%' } },
  { name: 'group', style: { width: '10%' } },
  { name: '', style: { width: '10%' } },
]
